import { auditReports } from '@mi-front/api-clients';
import { NullMessage } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { ClickAbsorber } from '../../../../../../../../components/base/ClickAbsorber';
import { AodRunActionsProps } from '../../../aod-rules-add/custom/AodFactory';
import { DownloadExportBtn } from './actions/DownloadExportBtn';
import { GoToReportBtn } from './actions/GoToReportBtn';
import { ViewReportResultsBtn } from './actions/ViewReportResultsBtn';
import { AdvancedRunActions } from './advanced-actions/AdvancedRunActions';

type Props = AodRunActionsProps;

export function AdaptiveRunActions({ run, display = 'short' }: Props) {
  const { $t } = useIntl();

  if (!run.reportId) {
    return display === 'short' ? null : (
      <NullMessage>
        {$t({
          id: 'audit.adaptiveRun.noActions',
          defaultMessage: 'Sin acciones',
        })}
      </NullMessage>
    );
  }

  return (
    <Box>
      <Box display="flex" gap={1}>
        {run.reportId && (
          <ClickAbsorber>
            <ViewReportResultsBtn run={run} buttonsVariant={display} />
          </ClickAbsorber>
        )}

        <GoToReportBtn run={run} buttonsVariant={display} />
        {run.status === auditReports.AodRunStatusEnum.COMPLETED_WITH_EXPORT && (
          <ClickAbsorber>
            <DownloadExportBtn
              fetchUrl={() =>
                run.rule.reportType === auditReports.AodRuleReportTypeEnum.AUDIT_GIP_STATUS
                  ? auditReports
                      .getGipReportEvidenceExportUrl1(run.reportId!)
                      .then((data) => data.downloadUrl)
                  : auditReports
                      .getGipAltReportEvidenceExportUrl1(run.reportId!)
                      .then((data) => data.downloadUrl)
              }
              buttonsVariant={display}
            />
          </ClickAbsorber>
        )}
      </Box>
      {display === 'long' && (
        <Box mt={3}>
          <AdvancedRunActions run={run} />
        </Box>
      )}
    </Box>
  );
}
